/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["outline-controls-drawer{display:block}outline-controls-drawer .slider-container{margin:0}outline-controls-drawer .content{flex-direction:column}"];
export { styles as styles };
